<template>
  <div class="maintenance-form">
    <h2 class="maintenance-form__title">メンテナンスを行う理由</h2>
    <textarea class="maintenance-form__memo" v-model="memo" placeholder="メンテナンスを行う理由を記載してください。" @input="$emit('edit', memo)" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      // メンテナンス理由
      memo: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';
@import '@/assets/sass/color.scss';

.maintenance-form {
  border-bottom: 1px solid $black_color;
  &__title {
    margin-bottom: 10px;
    font-size: 1.2rem;
    line-height: 1.4rem;
  }
  &__memo {
    width: 100%;
    font-size: 1.6rem;
    line-height: 1.9rem;
    resize: none;
    outline: none;
  }
}
</style>
